import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import SEOSchema from '@/components/feature/SEOSchema';

export default function About() {
  return (
    <>
      <SEOHead
        title="关于我们 - 品牌介绍、信誉展示与联系方式 | 麻将游戏在线玩"
        description="了解麻将游戏在线玩平台：品牌故事、核心价值、用户口碑和联系方式。数百万麻将爱好者信赖的在线麻将游戏平台。"
        keywords="关于我们,麻将游戏平台,品牌介绍,联系方式,麻将游戏在线玩"
        canonicalUrl="https://mahjong-online.com/about"
        ogTitle="关于我们 | 麻将游戏在线玩"
        ogDescription="了解麻将游戏在线玩平台：品牌故事、核心价值、用户口碑和联系方式。"
        ogUrl="https://mahjong-online.com/about"
      />
      <SEOSchema
        type="WebPage"
        data={{
          name: '关于我们',
          description: '麻将游戏在线玩平台品牌介绍、信誉展示与联系方式',
          url: 'https://mahjong-online.com/about',
        }}
      />

      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { name: '首页', path: '/' },
                { name: '关于我们' },
              ]}
            />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-4">
                关于麻将游戏在线玩
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                致力于为全球麻将爱好者提供最优质的在线麻将游戏体验
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-14">
              <div className="lg:col-span-2">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-4">品牌故事</h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    麻将游戏在线玩诞生于一群热爱麻将文化的开发者和玩家之手。我们深知麻将对中国人来说不仅仅是一种游戏，更是连接亲情、友情的纽带，是茶余饭后的欢乐源泉，是中华文化的重要组成部分。
                  </p>
                  <p>
                    在移动互联网时代，我们希望让这份传统乐趣突破时间和空间的限制。无论你身处何地，无论你使用什么设备，只要打开浏览器，就能立刻沉浸在正宗麻将的乐趣中。
                  </p>
                  <p>
                    从最初只有经典麻将一种玩法，到如今涵盖四川麻将、广东麻将、上海麻将、台湾麻将、日本立直麻将等十几种地方和国际玩法，我们始终坚持以用户体验为核心，不断优化游戏品质。
                  </p>
                  <p>
                    今天，超过500万玩家选择在我们的平台上享受麻将乐趣。这既是荣誉，也是责任。我们将继续努力，为每一位麻将爱好者提供更好的游戏体验。
                  </p>
                </div>
              </div>

              <div className="bg-background-100 rounded-lg p-6 flex flex-col items-center justify-center text-center">
                <div className="w-20 h-20 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                  <i className="ri-vip-crown-line text-3xl text-primary-600"></i>
                </div>
                <div className="text-3xl md:text-4xl font-heading text-primary-600 mb-2">500万+</div>
                <p className="text-sm text-foreground-600">累计服务玩家</p>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">我们的核心价值</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  { icon: 'ri-heart-line', title: '用户至上', desc: '一切以用户体验为核心，持续优化产品功能和界面设计' },
                  { icon: 'ri-shield-check-line', title: '公平公正', desc: '智能匹配系统确保公平对局，杜绝任何作弊行为' },
                  { icon: 'ri-global-line', title: '开放包容', desc: '汇集全球多种麻将玩法，尊重各地麻将文化差异' },
                  { icon: 'ri-lightbulb-line', title: '创新进取', desc: '不断引入新技术和新玩法，让传统麻将焕发新活力' },
                ].map((item) => (
                  <div key={item.title} className="flex gap-4 p-5 bg-background-100 rounded-lg">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-lg text-primary-600`}></i>
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">玩家口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {[
                  { name: '王先生', role: '资深麻将玩家', avatar: '王', comment: '玩了好几年了，从经典麻将到四川麻将，每种玩法都做得很好。客服响应也很快，推荐给身边的朋友都在玩！', rating: 5 },
                  { name: '李女士', role: '休闲游戏爱好者', avatar: '李', comment: '作为一个麻将新手，这里的教程真的帮了大忙。AI练习模式让我无压力学会了基本玩法，现在每天都要来几局！', rating: 5 },
                  { name: '张先生', role: '退休教师', avatar: '张', comment: '退休后每天和牌友们在线上打麻将，不用出门也能和朋友互动。界面简洁大字版对老年人很友好，非常满意！', rating: 4 },
                ].map((review) => (
                  <div key={review.name} className="p-5 bg-background-100 rounded-lg">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-700 font-semibold text-sm">
                        {review.avatar}
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">{review.name}</div>
                        <div className="text-xs text-foreground-500">{review.role}</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-0.5 mb-2">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{review.comment}</p>
                  </div>
                ))}
              </div>
            </div>

            <div id="contact" className="bg-background-100 rounded-lg p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">联系我们</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center p-4">
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-mail-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-600">support@mahjong-online.com</p>
                </div>
                <div className="text-center p-4">
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-customer-service-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线客服</h3>
                  <p className="text-sm text-foreground-600">工作日 9:00 - 18:00</p>
                </div>
                <div className="text-center p-4">
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-map-pin-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                  <p className="text-sm text-foreground-600">四川省成都市高新区天府大道</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}